import {
  InputUserVerificationSearch,
  InputUserVerificationUpdate,
  UserVerificationStatus,
  UserVerificationTypeEnum,
} from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import store from "@/store";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

export default function useUserVerification() {
  const { authUserStrict } = useAuthUser();

  const userVerificationSearch = async (data: InputUserVerificationSearch) => {
    return providers.UserVerificationProvider.search({ data });
  };
  const userVerificationStart = async (data: InputUserVerificationUpdate) => {
    return providers.UserVerificationProvider.start({ data });
  };

  const userVerificationApproved = async (userId: string): Promise<boolean> => {
    try {
      const { result } = await userVerificationSearch({ userIds: [userId] });
      const data = result.find(i => i.userId === userId);
      return data?.status !== UserVerificationStatus.UNVERIFIED ?? false;
    } catch (e) {
      return false;
    }
  };

  const userVerificationSetStatus = (status: UserVerificationStatus) => {
    store.commit(MUTATION_TYPES.SET_USER_VERIFICATION_STATUS, status);
  };

  const userVerificationFindMyStatus = async () => {
    const dataVerification = await userVerificationSearch({
      userIds: [authUserStrict.value.id],
      type: UserVerificationTypeEnum.CREATOR_VERIFICATION,
    });
    const userVerificationStatus =
      dataVerification.result.find(i => i.userId === authUserStrict.value.id)?.status ||
      UserVerificationStatus.UNVERIFIED;
    userVerificationSetStatus(userVerificationStatus);
  };

  return {
    userVerificationSearch,
    userVerificationStart,
    userVerificationApproved,
    userVerificationFindMyStatus,
    userVerificationSetStatus,
  };
}
